import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { PeopleService, PersonControllerGet200Response, Role } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class RoleService {
    protected readonly peopleService = inject(PeopleService);

    public async getRoleAssignmentCount(roleId: string): Promise<number> {
        const usersWithSpecifiedRole: PersonControllerGet200Response = await firstValueFrom(
            this.peopleService.personControllerGet({
                role: roleId,
            }),
        );

        return usersWithSpecifiedRole.totalItems;
    }

    public getRoleById(roles: Role[]): Record<string, Role> {
        return roles.reduce((acc: Record<string, Role>, role: Role) => {
            acc[role.id] = role;

            return acc;
        }, {});
    }

    public remainingAssignmentRolesCount(role: Role): Promise<number | null> | null {
        if (!role.maxNumberOfAssignments) {
            return null;
        }

        return this.remainingAssignmentUnitCount(role.maxNumberOfAssignments, role.id);
    }

    public async remainingAssignmentUnitCount(maxNumberOfAssignments: number, roleId: string): Promise<number> {
        return maxNumberOfAssignments - (await this.getRoleAssignmentCount(roleId));
    }
}
